import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Navbar,
  Collapse,
  Nav as BSNav,
  NavItem,
} from 'reactstrap';
import { NotFound, I18N } from 'commons';
import Footer from './Footer';

const EmptyNavItem = styled(NavItem)`
    padding: 16.5px 0;
`;

const ErrorPage = ({ orgName, titleCode, messageCode }) => (
  <div>
    <a href="#main_content" className="sr-only sr-only-focusable">
      <I18N>global.skip.to.main.content</I18N>
    </a>
    <header>
      <div className="container banner no-image">
        <I18N tag="strong" i18n-title="">
          {`welcome.h3, ${orgName}`}
        </I18N>
      </div>
    </header>
    <div className="nav-box">
      <Navbar color="dark" dark expand="md">
        <Collapse isOpen={false} navbar>
          <BSNav className="ml-auto" navbar>
            <EmptyNavItem><br /></EmptyNavItem>
          </BSNav>
        </Collapse>
      </Navbar>
    </div>
    <main id="main_content" className="container" tabIndex="-1">
      <div className="well ssp-well">
        <NotFound orgName={orgName} titleCode={titleCode} messageCode={messageCode} />
      </div>
    </main>
    <Footer />
  </div>
);

ErrorPage.propTypes = {
  orgName: PropTypes.string,
  titleCode: PropTypes.string,
  messageCode: PropTypes.string,
};

ErrorPage.defaultProps = {
  orgName: '',
  titleCode: '',
  messageCode: '',
};

export default ErrorPage;
